import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addCartItemToCart } from "../../actions/cartActions";
import { addCartItem } from "../../slices/cartSlice";
import { addToWishlist, removeFromWishlist } from "../../actions/userActions";
import { logEvent } from "../../actions/analyticsActions";

import orangewishlist from "../../images/wish-new -icon-orange.png";
import redwishlist from "../../images/wish-new -icon-red.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartPlus, faEye } from "@fortawesome/free-solid-svg-icons";

export default function Product({ product }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authState);
  const { wishlist } = useSelector((state) => state.wishlistState);
  const [quantity, setQuantity] = useState(1);
const [addedQuantity, setAddedQuantity] = useState(0);

  const isInWishlist = wishlist?.some((item) => item?._id === product?._id);

  // console.log("WishList", wishlist);
  const handleWishlistToggle = async (e) => {
    e.stopPropagation();

    // First frontend check
    if (!user) {
      toast.error("Please login to add to Wishlist");
      return;
    }

    if (isInWishlist) {
      const result = await dispatch(removeFromWishlist(product._id));

      if (result?.success) {
        toast.success("Removed from Wishlist");
      } else {
        toast.error(result?.message || "Failed to remove from Wishlist");
      }
    } else {
      const result = await dispatch(addToWishlist(product._id));

      if (result?.success) {
        toast.success("Added to Wishlist");
      } else {
        // Backend says 401
        if (result?.statusCode === 401) {
          toast.error("Please login to add to Wishlist");
        } else {
          toast.error(result?.message || "Failed to add to Wishlist");
        }
      }
    }
  };

const handleAddToCart = async (e) => {
  e.stopPropagation();

  // 🔐 Login check
  if (!user) {
    toast.error("Please login to add to cart");
    return;
  }

  const selectedVariant =
    product?.variants?.length > 0
      ? product.variants[0]
      : null;

  const availableStock = selectedVariant
    ? selectedVariant.stock
    : product.stock;

  // Check stock
  if (addedQuantity + 1 > availableStock) {
    toast.error("Quantity exceeds available stock");
    return;
  }

  const variantLabel = selectedVariant
    ? ` (${selectedVariant.variantName})`
    : "";

  const cartItem = {
    product: product._id,

    name: product.name + variantLabel,

    price: selectedVariant
      ? selectedVariant.offPrice
      : product.offPrice,

    image: selectedVariant
      ? selectedVariant.images?.[0]
      : product.images?.[0],

    stock: availableStock,

    quantity: 1,

    tax: product.tax,

    shippingCostlol: product.shippingCostlol,
    shippingCostNorth: product.shippingCostNorth,
    shippingCostEast: product.shippingCostEast,
    shippingCostWest: product.shippingCostWest,
    shippingCostSouth: product.shippingCostSouth,
    shippingCostCentral: product.shippingCostCentral,
    shippingCostNe: product.shippingCostNe,
    additionalShippingCost: product.additionalShippingCost,

    createdBy: product.createdBy,

    variant: selectedVariant
      ? {
          _id: selectedVariant._id,
          variantType: selectedVariant.variantType,
          variantName: selectedVariant.variantName,
          price: selectedVariant.price,
          offPrice: selectedVariant.offPrice,
          stock: selectedVariant.stock,
          images: selectedVariant.images,
        }
      : null,
  };

  // Only logged-in users reach here
  const result = await dispatch(addCartItemToCart(cartItem));

  // Increase badge only if backend add was successful
  if (result?.success) {
    setAddedQuantity((prev) => prev + 1);
  }
};

  const openProductDetailPage = () => {
    window.location.href = `/products/${product.clocreProductId}`;
  };

  return (
    <div className="product-card" onClick={openProductDetailPage}>
      <div className="product-tilt-effect">
        <div className="heart-top-right">
          <a onClick={handleWishlistToggle} style={{ cursor: "pointer" }}>
            <img
              src={isInWishlist ? redwishlist : orangewishlist}
              alt="Wishlist"
              style={{
                width: "36px",
                height: "36px",
                objectFit: "contain",
              }}
            />
          </a>
        </div>
        <div className="product-image" style={{ fontSize: "14px" }}>
          <img
            src={
              product?.images?.[0] ||
              product?.variants?.[0]?.images?.[0] ||
              product?.variants?.[1]?.images?.[0] ||
              "/images/default.jpg"
            }
            alt={product.name}
          />
        </div>
      </div>
      <div className="product-info">
        <div className="product-meta mb-1 condition-stock-row">
          <div className="product-stock">In Stock</div>

          {product?.condition && (
            <div
              className={`product-condition ${
                product.condition === "Unboxed (Excess Inventory)" ||
                product.condition === "Surplus (Excess Inventory)"
                  ? "product-condition-surplus"
                  : product.condition === "Refurbished"
                    ? "product-condition-refurbished"
                    : "product-condition-new"
              }`}
            >
              {product.condition === "Unboxed (Excess Inventory)" ||
              product.condition === "Surplus (Excess Inventory)"
                ? "Surplus"
                : product.condition === "Refurbished"
                  ? "Refurbished"
                  : "New"}
            </div>
          )}
        </div>
        <div className="product-category">
          {(() => {
            const words = product.category?.split(" ") || [];
            if (words.length > 2) {
              return `${words.slice(0, 2).join(" ")}...`;
            }
            return product.category;
          })()}
        </div>
        <h2 className="product-title">
          {(() => {
            const maxLength = 40;
            return product.name.length > maxLength
              ? `${product.name.slice(0, maxLength)}...`
              : product.name;
          })()}
        </h2>

        <div className="product-features">
          <span className="feature">By {product.brand}</span>
        </div>
        <div className="product-bottom">
          <div className="price-row">
            <span className="price-now">
              ₹
              {Number(
                product?.variants?.length > 0
                  ? product.variants[0]?.offPrice
                  : product?.offPrice,
              ).toFixed(2)}
              /-
            </span>

            <span className="price-was">
              ₹
              {Number(
                product?.variants?.length > 0
                  ? product.variants[0]?.price
                  : product?.price,
              ).toFixed(2)}
              /-
            </span>
          </div>
        </div>

<button className="product-button">
  <div
    className="view-section"
    onClick={openProductDetailPage}
  >
    <FontAwesomeIcon icon={faEye} />
    <span>View</span>
  </div>

  <div
    className="add-section"
    onClick={handleAddToCart}
  >
    <FontAwesomeIcon icon={faCartPlus} />
    <span>Add</span>

    {addedQuantity > 0 && (
      <span className="cart-add-badge">
        {addedQuantity}
      </span>
    )}
  </div>
</button>
      </div>
    </div>
  );
}
